import { formatDate } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BizzCustomersService } from 'src/app/_business-dashboard/_services/bizz-customers.service';
import { PlanDataService } from 'src/app/_services/plan-data.service';
import { LocationRegisterList } from 'src/app/_data/location-resgister';
import {
    readUpcomingInvoiceAmount,
    readUpcomingInvoiceTaxAmount,
    isSubscriptionAddonActive,
    calculateSubscriptionRecurringSubtotal,
    calculateSubscriptionRecurringTaxAmount,
    calculateSubscriptionRecurringTotal,
} from 'src/app/_components/_signup/subscription-plans/subscription-plans-lincsell/billing-and-plans/billing-and-plans-calculation';
import { AdditionItemsPriceInfo } from 'src/app/_models/subscription-management/addition-items-price-info';
import { BillingSummaryInfo } from 'src/app/_models/subscription-management/billing-summary-info';
import { CurrentPlanGeneralInformation } from 'src/app/_models/subscription-management/current-plan-general-info';
import { PlanInformationList } from 'src/app/_models/subscription-management/plan-information';
import {
    SubscriptionModel,
    BusinessSetupModel,
} from 'src/app/_models/subscription-management/subscription-model';
import {
    UserSubscriptionDetail,
    PlanInfo,
    UserSubscriptionInfo,
} from 'src/app/_models/subscription-management/user-subscription-info';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { BaseService } from 'src/app/_services/base.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { GlobalService } from 'src/app/_services/global.service';
import { SignupService } from 'src/app/_services/signup.service';
import { SubscriptionPlanService } from 'src/app/_services/subscription-plan.service';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-subscription-detail-of-customer',
    templateUrl: './subscription-detail-of-customer.component.html',
    styleUrls: ['./subscription-detail-of-customer.component.scss'],
})
export class SubscriptionDetailOfCustomerComponent implements OnInit {
    @HostListener('window:resize', ['$event'])
    _globals = GlobalService;
    planName: string = '30-Day Free Trial';
    planAmount: string = '$30.00';

    messageText: string =
        'You are currently on 30-day free trial of Connect-360. You may continue to explore our software within 30-day free trial or you can subscribe to one of pricing plans below. All of your uploaded data i.e. products, customers etc will be wiped out from the system after 30 days.';

    currentPlanGeneralInformation: CurrentPlanGeneralInformation[] = [];
    billingPeriod: any[];
    selectedBillingPeriod: string = 'Monthly';
    planInformation = PlanInformationList;
    listSubscriptions = [];
    featuresArray: string[] = [];
    planDetails: any[] = [];
    currentPlanSubscription = <UserSubscriptionDetail>{};
    additionItemsPriceInfoHeader: string[] = [];
    additionItemsPriceInfo: AdditionItemsPriceInfo[] = [];
    billingSummaryInfo: BillingSummaryInfo[] = [];
    userCurrentPlan = <PlanInfo>{};
    loadingContent: boolean = false;
    totalLocation: number = 1;
    totalRegisters: number = 1;
    subscriptionCost: number = 79.99;
    additionalLocationCost: number = 0;
    additionalRegisterCost: number = 0;
    grandBill: number = 0;

    additionalRegisterPerLocationPrice: number = 0;
    additionalLocationNotAvailable: boolean = false;
    @Input() planInfo = <SubscriptionModel>{};
    @Input() businessSetup = <BusinessSetupModel>{};
    costHeading: string = '';

    showSubscriptionModal: boolean = false;
    additionalLocationString: string = '';
    additionalLocationPrice: number = 0;

    additionalRegisterString: string = '';
    additionalRegisterPrice: number = 0;

    disabledTrue: boolean = false;
    planPricePerMonth: number = 0;
    loyaltyProgramPriceString: string = '$0';
    taxRate: number = 0;
    loyaltyProgramPrice: number = 0;
    basePlanPrice: number = 0;
    subscribedPackages: any[] = [];
    currentSubscription = <any>{};
    planDuration: number = 1;
    cancellationRequest: boolean = false;
    upgradeRequested: boolean = false;

    /** Hidden: "Expires on" tile in the free-trial Subscribed Plan card. Flip to true to re-enable. */
    EXPIRES_ON_TILE_ENABLED = false;

    //Sam Changes

    stateOptions = [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
    ];
    invoiceDetail: any = [];
    productsDetail: any = [];
    showBuyMoreLocationForm: boolean = false;
    showBuyMoreRegisterForm: boolean = false;
    showSupportRequestForm: boolean = false;
    showPurchaseAddon: boolean = false;
    talkToExpertForm: boolean = false;
    showWebsiteSelectionPopup: boolean = false;
    showLoyaltyProgramSelectionPopup: boolean = false;

    @HostListener('window:resize', ['$event'])
    displaySubscriptionPlan = false;

    directPurchase: boolean = false;
    addtionalAddonsQuestion: string = '';
    additionalAddonRequestionMessage: string = '';
    generalQuestion: string = '';
    generalMessage: string = '';

    currentLocations = <any>{};
    currentRegisters = <any>{};
    getSubPlan: any;
    staticWebsite = <any>{};
    buyLocQty = 0;
    buyRegQty = 0;

    //whiteLabelList = WhiteLabelList
    who: any = null;
    currentPlanID: number = 0;
    changedPlanID: number = 0;

    selectedPlanForSubscription = <any>{};
    planChanged: boolean = false;

    buylocationList = <any>{};
    buyRegisterList = <any>{};
    ShowCustomConfirmation = false;
    confirmationText: any;
    CurrentAction = 0;

    subscriptionCharges: number = 0;
    businessSetupObj: any = {};
    planObj: any = {};
    addonsList: any[] = [];
    hardwareList: any[] = [];
    displaySubscribedPackages: any[] = [];
    displaySubTotal: number = 0;
    displayTax: number = 0;
    displayTotalCharges: number = 0;

    // The real, rich SubscriptionModel (planCost, totalCost, subTotalCost, totalTaxAmount,
    // subscriptionPlanPkg[], subscribedFeatures[], nextChargeDate, startDate, totalTaxValue,
    // planId) — confirmed present directly on activeItem.subscription (spread through by
    // normalizeCustomerDetailData's `...source`), the SAME way activeItem.noOfLocations /
    // .perNoOfRegister / .platformFeeType are already read elsewhere in this admin codebase (see
    // bizz-customer-plan-configuration.component.ts). activeItem.currentSubscription (used above
    // for planName/subscriptionExpire/total) is a SEPARATE, smaller report-summary projection that
    // goes stale the moment a customer changes plans (confirmed: a customer upgraded Free -> Plus
    // and that summary still showed Free/$0.00/no due date) — activeItem.subscription does not have
    // that staleness problem, so it's used as the primary source for everything below.
    liveSubscription: any = null;
    liveInvoice: any = null;
    livePlanTitle: string | null = null;
    // Live GetSubscriptions (V1) match for the viewed customer's plan, by title — supplies the
    // real, plan-specific optional-addon catalog (subscriptionAddons), same source
    // BillingAndPlansComponent.loadLivePlanExtras() reads for the customer's own self-service page.
    livePlanExtras: any = null;

    private loadLiveSubscriptionSnapshot(): void {
        const activeItem = this._bizzCustomerService.activeItem;
        // Synchronous baseline — always available immediately, no network round trip, and doesn't
        // suffer the currentSubscription summary's staleness problem (see field doc comment above).
        this.liveSubscription = activeItem?.subscription ?? activeItem?.Subscription ?? this.liveSubscription;

        const cosmosId = this.liveSubscription?.planId ?? this.liveSubscription?.PlanId;
        if (cosmosId != null) {
            const matched = this._planData.list.find((p: any) => String(p.cosmosId) === String(cosmosId));
            if (matched?.planName) this.livePlanTitle = matched.planName;
        }
        // lastPlanChangeToPlanTitle is a reasonable fallback if the local catalog is missing this
        // plan — it's "the plan last changed into," which equals the current plan unless the account
        // has changed plans again since without that being reflected here.
        if (!this.livePlanTitle) {
            this.livePlanTitle = activeItem?.lastPlanChangeToPlanTitle || activeItem?.LastPlanChangeToPlanTitle || null;
        }
        this.loadLivePlanExtras(this.liveCatalogEntry?.planName || this.livePlanTitle || this.planName);

        const businessName = activeItem?.currentSubscription?.businessNameWithDomain;
        if (!businessName) return;
        // Soft enhancement only — the upcoming-invoice numbers aren't on activeItem.subscription
        // itself, so this fetch is worth attempting, but every consumer of liveInvoice below already
        // falls back to liveSubscription's own totalCost/subTotalCost/totalTaxAmount if this never
        // resolves or the endpoint doesn't return admin-scoped data as expected.
        this._subscriptionPlanService.getBusinessInvoice(businessName).pipe(
            catchError(() => of(null)),
        ).subscribe((res: any) => {
            if (!res || res.responseStatusCode !== 903) return;
            // GetBusinessInvoice ignores the BusinessName header for admin/staff sessions and
            // returns the CALLER's own account invoice instead (confirmed live: an admin session
            // requesting a customer's invoice got back the admin's own "Administration" account).
            // Reject a response that isn't actually for the business we asked about so it can't
            // blend the admin's own invoice/subscription into this customer's totals.
            const returnedBusinessName = String(
                res.data?.currentSubscription?.businessNameWithDomain
                ?? res.data?.businessNameWithDomain
                ?? ''
            ).trim().toLowerCase();
            if (returnedBusinessName && returnedBusinessName !== String(businessName).trim().toLowerCase()) {
                return;
            }
            this.liveInvoice = res.data?.invoice || null;
            if (!this.liveSubscription && res.data?.currentSubscription) {
                this.liveSubscription = res.data.currentSubscription;
            }
        });
        // The bundled plan-list.json catalog above can miss a plan (renamed/added server-side since
        // the last bundle) — top it up with the live catalog's own title, matched by the same
        // cosmosId, same fallback order billing-and-plans.component.ts's loadLiveCurrentPlanTitle()
        // already established for this exact "planName often blank/stale" problem.
        this._subscriptionPlanService.getSubscriptionPlanListV2().pipe(
            catchError(() => of(null)),
        ).subscribe((res: any) => {
            if (this.livePlanTitle) return;
            const cosmosId = this.liveSubscription?.planId ?? this.liveSubscription?.PlanId;
            if (cosmosId == null) return;
            const plans = res?.data ?? res?.Data ?? [];
            const matched = (Array.isArray(plans) ? plans : []).find(
                (p: any) => String(p?.cosmosId ?? p?.CosmosId ?? '') === String(cosmosId)
            );
            const title = matched?.title ?? matched?.Title;
            if (title) this.livePlanTitle = title;
        });
    }

    private loadLivePlanExtras(planTitle: string): void {
        const name = String(planTitle || '').trim().toLowerCase();
        if (!name) return;
        this._subscriptionPlanService.getSubscriptionPlanList().pipe(
            catchError(() => of(null)),
        ).subscribe((res: any) => {
            const plans = res?.data ?? res?.Data ?? res ?? [];
            this.livePlanExtras = (Array.isArray(plans) ? plans : []).find(
                (p: any) => String(p?.title ?? p?.Title ?? '').trim().toLowerCase() === name
            ) || null;
        });
    }

    /** The bundled plan-list.json catalog entry for the live subscription's plan — gives the
     *  included-register/location defaults and the plan's local addon list, matched by cosmosId
     *  same as billing-and-plans.component.ts's matchedPlanCatalogEntry(). */
    get liveCatalogEntry(): any {
        const cosmosId = this.liveSubscription?.planId ?? this.liveSubscription?.PlanId;
        if (cosmosId != null) {
            const matchedById = this._planData.list.find((p: any) => String(p.cosmosId) === String(cosmosId));
            if (matchedById) return matchedById;
        }
        // No liveSubscription (e.g. this admin report row never got a `.subscription` field) — fall
        // back to matching by plan name, since displayPlanName is still reliable off
        // lastPlanChangeToPlanTitle/planName even without a live subscription object.
        const name = String(this.displayPlanName || '').trim().toLowerCase();
        if (!name || name === '-') return null;
        return this._planData.list.find((p: any) => String(p.planName || '').trim().toLowerCase() === name) || null;
    }

    /** Billable-extra qty from the live subscription's SubscribedFeatures, keyed by the backend's
     *  Type code — Type 6 = AdditionalRegister, Type 7 = AdditionalLocationPlus1Reg. Same logic as
     *  billing-and-plans.component.ts's billableExtraQtyFromFeatures(), adapted to read directly off
     *  liveSubscription instead of businessSetup[0].subscription. */
    private billableExtraQty(type: 6 | 7, legacyTitleIncludes: string): number {
        const features: any[] = this.liveSubscription?.subscribedFeatures ?? this.liveSubscription?.SubscribedFeatures ?? [];
        const hasTypedEntries = features.some((f: any) => (f?.type ?? f?.Type) != null);
        if (hasTypedEntries) {
            return features.reduce((sum: number, f: any) => {
                const isActive = f?.isActive ?? f?.IsActive;
                const featureType = this.getNumericAmount(f?.type ?? f?.Type);
                if (!isActive || featureType !== type) return sum;
                return sum + this.getNumericAmount(f?.qty ?? f?.Qty);
            }, 0);
        }
        return features.reduce((sum: number, f: any) => {
            const title = String(f?.title ?? f?.Title ?? '').trim().toLowerCase();
            const isActive = f?.isActive ?? f?.IsActive;
            const isAddon = f?.isAddon ?? f?.IsAddon;
            if (!isActive || !isAddon || !title.includes(legacyTitleIncludes)) return sum;
            return sum + this.getNumericAmount(f?.qty ?? f?.Qty);
        }, 0);
    }

    get includedLocationCount(): number {
        return this.getNumericAmount(this.liveCatalogEntry?.defaultLocation) || 1;
    }

    get includedRegisterCount(): number {
        return this.getNumericAmount(this.liveCatalogEntry?.defaultRegister) || 1;
    }

    get extraLocationCount(): number {
        // billableExtraQty needs liveSubscription.subscribedFeatures — without a liveSubscription,
        // derive extras from the account-level total vs. the plan's included count instead (same
        // "total is the trusted source" preference totalLocationCount itself already uses).
        if (this.liveSubscription) return this.billableExtraQty(7, 'location');
        return Math.max(0, this.totalLocationCount - this.includedLocationCount);
    }

    get extraRegisterCount(): number {
        if (this.liveSubscription) return this.billableExtraQty(6, 'regist');
        return Math.max(0, this.totalRegisterCount - this.includedRegisterCount);
    }

    // Total register/location count is the account-level total (activeItem.perNoOfRegister /
    // .noOfLocations, confirmed present directly on activeItem same as above) — same preference
    // order billing-and-plans.component.ts's registerCount/locationCount getters already use
    // (account-level total over included+extra, since included+extra is a derived approximation
    // that can drift from what the account was actually billed/provisioned for).
    get totalLocationCount(): number {
        const activeItem = this._bizzCustomerService.activeItem;
        return this.getNumericAmount(activeItem?.noOfLocations) || (this.includedLocationCount + this.extraLocationCount);
    }

    get totalRegisterCount(): number {
        const activeItem = this._bizzCustomerService.activeItem;
        return this.getNumericAmount(activeItem?.perNoOfRegister) || this.getNumericAmount(activeItem?.noOfRegisters) || (this.includedRegisterCount + this.extraRegisterCount);
    }

    // Real per-extra pricing — same catalog PaymentPageComponent/BillingAndPlansComponent price
    // "Number of Register"/"Number of Location" line items from.
    readonly registerExtraPrice = LocationRegisterList.find((i) => i.id === 1)?.price ?? 49;
    readonly locationExtraPrice = LocationRegisterList.find((i) => i.id === 2)?.price ?? 79;

    // Hidden: duplicates the same locations/registers rows the Subscription Details table below
    // already shows (qty + real price), which this admin page has no "Buy more" action to justify
    // showing twice for.
    get showLocationsRegistersCard(): boolean {
        return false;
    }

    /** "Advanced Loyalty Program" -> "advancedLoyaltyProgram" — the admin GetReport row exposes
     *  entitlement flags under exactly this camelCased-title convention (confirmed: "Standard
     *  Customer App" -> activeItem.standardCustomerApp, "Advanced Loyalty Program" ->
     *  activeItem.advancedLoyaltyProgram), used as the addon-purchased signal when there's no
     *  liveSubscription to check isSubscriptionAddonActive against. */
    private toCamelCase(title: string): string {
        return String(title || '')
            .trim()
            .split(/\s+/)
            .filter(Boolean)
            .map((word, i) => i === 0
                ? word.charAt(0).toLowerCase() + word.slice(1)
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join('');
    }

    /** Which optional add-ons apply to this plan, and whether the customer has purchased each —
     *  same logic/fallback order as billing-and-plans.component.ts's subscriptionAddonsList,
     *  adapted to the viewed customer's liveSubscription instead of the logged-in user's own. */
    get liveSubscriptionAddonsList(): any[] {
        const localAddons = this.liveCatalogEntry?.addons || [];
        const liveAddons: any[] | null = Array.isArray(this.livePlanExtras?.subscriptionAddons)
            ? this.livePlanExtras.subscriptionAddons
            : null;

        let planAddons: any[];
        if (liveAddons) {
            const localByName = new Map<string, any>(
                localAddons.map((a: any) => [String(a.planName || '').trim().toLowerCase(), a])
            );
            planAddons = liveAddons.filter((a: any) => a?.title).map((a: any) => {
                const name = String(a.title).trim();
                const localMatch = localByName.get(name.toLowerCase());
                return {
                    id: a.id ?? localMatch?.id,
                    planName: name,
                    detail: a.detail || localMatch?.detail || name,
                    monthlyPrice: this.getNumericAmount(a.monthlyPrice),
                    yearlyPrice: this.getNumericAmount(a.yearlyPrice ?? a.monthlyPrice),
                    defaultAddedInSubscription: a.defaultAddedInSubscription ?? localMatch?.defaultAddedInSubscription ?? false,
                };
            });
        } else {
            planAddons = localAddons;
        }

        return planAddons.filter((a: any) => !a.defaultAddedInSubscription).map((addon: any) => ({
            ...addon,
            included: this.liveSubscription
                ? isSubscriptionAddonActive(this.liveSubscription, addon)
                : !!this._bizzCustomerService.activeItem?.[this.toCamelCase(addon.planName || addon.title)],
        }));
    }

    get activeLiveAddonCount(): number {
        return this.liveSubscriptionAddonsList.filter((a) => a.included).length;
    }

    // Hidden: duplicates the same add-on row the Subscription Details table below already shows.
    get showAddonsCard(): boolean {
        return false;
    }

    /** A purchased-package line from the live subscription's SubscriptionPlanPkg array, by packageId
     *  — packageId '1' = extra registers, '2' = extra locations, an addon's own id for add-ons. Same
     *  array billing-and-plans-calculation.ts's packageLineById()/matchingPackageLine() already read
     *  for real per-line pricing. */
    private liveSubscriptionPackageLine(packageId: string | null): any {
        if (!packageId) return null;
        const lines: any[] = this.liveSubscription?.subscriptionPlanPkg ?? this.liveSubscription?.SubscriptionPlanPkg ?? [];
        return lines.find((l: any) => String(l?.packageId ?? l?.PackageId ?? '') === packageId) || null;
    }

    /** Subscription Details table rows, built from the live subscription's own real fields
     *  (planCost, SubscriptionPlanPkg extra-register/location lines, purchased add-ons) rather than
     *  the GetReport row's subscribedPackages, which reflects the plan at report-generation time and
     *  can be stale. Empty when no live subscription has been fetched yet. */
    get liveDisplaySubscribedPackages(): any[] {
        if (!this.liveSubscription && !this.liveCatalogEntry) return [];
        const basePrice = this.getNumericAmount(this.liveSubscription?.planCost)
            || this.getNumericAmount(this.liveCatalogEntry?.monthlyPrice);
        const rows: any[] = [
            { title: this.displayPlanName, displayQty: null, displayPrice: basePrice },
        ];

        if (this.extraLocationCount > 0) {
            const line = this.liveSubscriptionPackageLine('2');
            const price = line
                ? this.getNumericAmount(line.subTotalCost ?? line.totalPrice)
                : this.locationExtraPrice * this.extraLocationCount;
            rows.push({ title: 'Additional Location', displayQty: this.extraLocationCount, displayPrice: price });
        }

        if (this.extraRegisterCount > 0) {
            const line = this.liveSubscriptionPackageLine('1');
            const price = line
                ? this.getNumericAmount(line.subTotalCost ?? line.totalPrice)
                : this.registerExtraPrice * this.extraRegisterCount;
            rows.push({ title: 'Additional Register', displayQty: this.extraRegisterCount, displayPrice: price });
        }

        this.liveSubscriptionAddonsList.filter((a: any) => a.included).forEach((addon: any) => {
            const line = this.liveSubscriptionPackageLine(addon.id != null ? String(addon.id) : null);
            const price = line
                ? this.getNumericAmount(line.subTotalCost ?? line.totalPrice)
                : this.getNumericAmount(addon.monthlyPrice);
            rows.push({ title: addon.planName, displayQty: null, displayPrice: price });
        });

        return rows;
    }

    get displaySubscriptionLineItems(): any[] {
        const liveRows = this.liveDisplaySubscribedPackages;
        return liveRows.length ? liveRows : this.displaySubscribedPackages;
    }

    /** Same tax-rate source SubscriptionModel carries per-account (totalTaxValue) — the viewed
     *  customer's own rate, not the logged-in admin's. */
    get liveTaxRate(): number {
        return this.getNumericAmount(this.liveSubscription?.totalTaxValue ?? this.liveSubscription?.TotalTaxValue);
    }

    /** Sum of what's actually rendered in the Subscription Details table — used only as the
     *  no-liveSubscription fallback for the totals below, so the displayed totals can never
     *  contradict the displayed line items. */
    private get reportLineItemsSubtotal(): number {
        return this.liveDisplaySubscribedPackages.reduce(
            (sum: number, row: any) => sum + this.getNumericAmount(row.displayPrice), 0
        );
    }

    // These prefer the backend's own stored subTotalCost/totalTaxAmount/totalCost (confirmed real
    // and exact against a live account: $340.00 / $28.05 / $368.05) over recalculating from scratch
    // — the calculation helpers are kept only as a defensive fallback for the rare case those
    // fields come back zeroed (matches how the rest of this codebase treats a live "0" as untrusted).
    get displaySubTotalAmount(): number {
        if (this.liveSubscription) {
            const subTotal = this.getNumericAmount(this.liveSubscription.subTotalCost ?? this.liveSubscription.SubTotalCost);
            return subTotal > 0 ? subTotal : calculateSubscriptionRecurringSubtotal(this.liveSubscription, this.liveSubscriptionAddonsList);
        }
        if (this.liveCatalogEntry) return this.reportLineItemsSubtotal;
        return this.displaySubTotal;
    }

    get displayTaxAmount(): number {
        if (this.liveSubscription) {
            const tax = this.getNumericAmount(this.liveSubscription.totalTaxAmount ?? this.liveSubscription.TotalTaxAmount);
            return tax > 0 ? tax : calculateSubscriptionRecurringTaxAmount(this.liveSubscription, this.liveSubscriptionAddonsList, this.liveTaxRate);
        }
        // No liveSubscription.totalTaxValue to read a rate from — this.taxRate (businessSetup.taxRate,
        // set in initSubscriptionFormInfo) is the only rate source left, and is 0 when that field
        // isn't present either, in which case this correctly shows $0 tax rather than guessing a rate.
        if (this.liveCatalogEntry) return this.reportLineItemsSubtotal * (this.taxRate / 100);
        return this.displayTax;
    }

    get displayTotalChargesAmount(): number {
        if (this.liveSubscription) {
            const total = this.getNumericAmount(this.liveSubscription.totalCost ?? this.liveSubscription.TotalCost);
            return total > 0 ? total : calculateSubscriptionRecurringTotal(this.liveSubscription, this.liveSubscriptionAddonsList, this.liveTaxRate);
        }
        if (this.liveCatalogEntry) return this.displaySubTotalAmount + this.displayTaxAmount;
        return this.displayTotalCharges;
    }

    /** Base-plan row from the (possibly stale, but usually still-accurate for the plan *name* on a
     *  Free/never-changed account) GetReport subscribedPackages list — the row that isn't one of the
     *  Locations/Registers count rows. */
    private get subscribedPackagesPlanName(): string | null {
        const planRow = (this.subscribedPackages || []).find(
            (pkg: any) => pkg?.title && pkg.title !== 'Allowed Locations' && pkg.title !== 'Allowed Registers'
        );
        return planRow?.title || null;
    }

    /** Current Plan tile — prefers the live catalog-resolved title, then the GetReport row's own
     *  planName, then the GetReport subscribedPackages' base-plan row title (covers a Free-tier,
     *  non-trial account where planName comes back blank), then a free-trial fallback. */
    get displayPlanName(): string {
        return this.livePlanTitle
            || this.planName
            || this.subscribedPackagesPlanName
            || (this.isActuallyFreeTrial ? 'Free' : '-');
    }

    /** Most recent plan change (e.g. "Free -> Plus"), from lastPlanChange* fields — on the
     *  customer's own self-service page these come from businessSetup[0] via GETUSERBYUSERNAME
     *  (a login-scoped API the admin can't call for another business), so this best-effort reads
     *  the same field names off whatever GetReport's businessSetup happened to include and returns
     *  null (hiding the line) if they're absent, rather than guessing at a different source. */
    get lastPlanChange(): { fromTitle: string; toTitle: string; date: any } | null {
        const activeItem = this._bizzCustomerService.activeItem;
        const fromTitle = activeItem?.lastPlanChangeFromPlanTitle ?? activeItem?.LastPlanChangeFromPlanTitle;
        const toTitle = activeItem?.lastPlanChangeToPlanTitle ?? activeItem?.LastPlanChangeToPlanTitle;
        const date = activeItem?.lastPlanChangeDate ?? activeItem?.LastPlanChangeDate;
        if (!fromTitle || !toTitle) return null;
        return { fromTitle, toTitle, date };
    }

    /** Pending plan-change request (e.g. a downgrade/upgrade requested but not yet applied), from
     *  the changePlanRequest* fields on GetReport's businessSetup row. Returns null when there is
     *  no pending request (changePlanRequest false/absent) so the template can hide the note. */
    get pendingPlanChangeRequest(): { status: string; message: string; date: any } | null {
        const activeItem = this._bizzCustomerService.activeItem;
        const isPending = activeItem?.changePlanRequest ?? activeItem?.ChangePlanRequest;
        if (!isPending) return null;
        const status = activeItem?.changePlanRequestStatus ?? activeItem?.ChangePlanRequestStatus ?? '';
        const message = activeItem?.changePlanRequestMessage ?? activeItem?.ChangePlanRequestMessage ?? '';
        const date = activeItem?.changePlanRequestDate ?? activeItem?.ChangePlanRequestDate;
        return { status, message, date };
    }

    /** Subscribed On tile — from the live subscription's startDate (or freeTrialStartDate), falling
     *  back to the GetReport row's createdDate. */
    get displaySubscribedOnDate(): any {
        const liveDate = this.liveSubscription?.startDate ?? this.liveSubscription?.freeTrialStartDate;
        if (this.isValidDateValue(liveDate)) return liveDate;
        const fallback = this._bizzCustomerService.activeItem?.currentSubscription?.createdDate;
        return this.isValidDateValue(fallback) ? fallback : null;
    }

    get hasSubscribedOnDate(): boolean {
        return this.isValidDateValue(this.displaySubscribedOnDate);
    }

    /** Next Due Date tile — prefers the live subscription's nextChargeDate over the GetReport row's
     *  subscriptionExpire, which can be stale or DateTime.MinValue. */
    get displayNextDueDate(): any {
        const liveDate = this.liveSubscription?.nextChargeDate ?? this.liveSubscription?.NextChargeDate;
        if (this.isValidDateValue(liveDate)) return liveDate;
        const fallback = this._bizzCustomerService.activeItem?.currentSubscription?.subscriptionExpire;
        if (this.isValidDateValue(fallback)) return fallback;
        // No live subscription and no valid subscriptionExpire on this report row (e.g. still
        // DateTime.MinValue) — best-effort: Subscribed On plus billing intervals until it's in the
        // future, the same cadence a Stripe-style subscription actually renews on.
        if (!this.liveCatalogEntry) return null;
        const subscribedOn = this.displaySubscribedOnDate;
        if (!this.isValidDateValue(subscribedOn)) return null;
        const interval = this._bizzCustomerService.activeItem?.currentSubscription?.subscriptionInterval
            ?? this._bizzCustomerService.activeItem?.subscriptionInterval;
        const stepMonths = interval === 1 ? 1 : 12;
        const next = new Date(subscribedOn);
        const now = new Date();
        while (next <= now) next.setMonth(next.getMonth() + stepMonths);
        return next;
    }

    /** Next Payment tile — prefers the live upcoming-invoice amount, then the live subscription's
     *  own totalCost, then the report-derived total (see displayTotalChargesAmount), falling back
     *  to the GetReport row's total last. */
    get displayNextPaymentAmount(): number {
        const invoiceAmount = readUpcomingInvoiceAmount(this.liveInvoice);
        if (invoiceAmount > 0) return invoiceAmount;
        const liveTotal = this.getNumericAmount(this.liveSubscription?.totalCost);
        if (liveTotal > 0) return liveTotal;
        if (this.liveCatalogEntry) return this.displayTotalChargesAmount;
        return this.getNumericAmount(this.subscriptionCharges);
    }

    /** Tax portion of displayNextPaymentAmount, from the live upcoming invoice — used to show the
     *  "$340.00 + $28.05 tax" breakdown under the Next Payment tile. */
    get displayNextPaymentTaxAmount(): number {
        const invoiceTax = readUpcomingInvoiceTaxAmount(this.liveInvoice);
        if (invoiceTax > 0) return invoiceTax;
        const liveTax = this.getNumericAmount(this.liveSubscription?.totalTaxAmount);
        if (liveTax > 0) return liveTax;
        return this.liveCatalogEntry ? this.displayTaxAmount : 0;
    }

    get displayNextPaymentSubtotal(): number {
        const subTotal = this.getNumericAmount(this.liveSubscription?.subTotalCost);
        if (subTotal > 0) return subTotal;
        return Math.max(0, this.displayNextPaymentAmount - this.displayNextPaymentTaxAmount);
    }

    get hasNextPaymentTaxBreakdown(): boolean {
        return this.displayNextPaymentTaxAmount > 0;
    }

    get hasAddons(): boolean {
        return this.currentSubscription?.isAddons === true || this.currentSubscription?.IsAddons === true;
    }

    get hasHardware(): boolean {
        return this.currentSubscription?.isHardware === true || this.currentSubscription?.IsHardware === true;
    }

    /** activeItem.isFreeTrial (a GetReport flag) can go stale the same way currentSubscription
     *  does — confirmed live: an account that upgraded off its free trial still had isFreeTrial:
     *  true on this report row while its own self-service Subscription page showed an active paid
     *  plan. Treat the account as paid (not a free trial) whenever there's live evidence of a real
     *  subscription — a subscription record with a planId, or a currentSubscription with an actual
     *  charge/plan name — even if the stale flag still says free trial. */
    get isActuallyFreeTrial(): boolean {
        const activeItem = this._bizzCustomerService.activeItem;
        if (!activeItem?.isFreeTrial) return false;

        const liveSub = activeItem?.subscription ?? activeItem?.Subscription;
        if ((liveSub?.planId ?? liveSub?.PlanId) != null) return false;

        const currentSub = activeItem?.currentSubscription;
        if (currentSub && (this.getNumericAmount(currentSub.total) > 0 || currentSub.planName)) return false;

        return true;
    }

    constructor(
        private _subscriptionPlanService: SubscriptionPlanService,
        private router: Router,
        private route: ActivatedRoute,
        private _spinner: NgxSpinnerService,
        public _bizzCustomerService: BizzCustomersService,
        private _confirmationService: ConfirmationService,
        private _abd: AppBaseDataService,
        private _bs: BaseService,
        public _signup: SignupService,
        private _userService: UserService,
        private _router: Router,
        private _messageService: MessageService,
        private _connMessageService: ConnMessageService,
        private _planData: PlanDataService
    ) { }

    ngOnInit(): void {
        this.initSubscriptionFormInfo();
        // this.getUserCurrentSubscriptionDetails();
    }

    // initSubscriptionFormInfo() {
    //     this.userCurrentPlan =
    //         this._bizzCustomerService.activeItem

    //    let item = this._bizzCustomerService.activeItem.invoice
    //     this.taxRate = this._bizzCustomerService.activeItem.subscriptionInvoice?.taxRate
    //     this.planDuration = this._bizzCustomerService.activeItem.subscriptionInterval
    //     this.cancellationRequest = this._bizzCustomerService.activeItem.cancellationRequest
    //     this.upgradeRequested = this._bizzCustomerService.activeItem.upgradeRequested
    //     this.planName = this._bizzCustomerService.activeItem.currentSubscription?.planName;
    //     if (this._bizzCustomerService.activeItem.isFreeTrial) {

    //         let startDate: Date = new Date(this._bizzCustomerService.activeItem.freeTrialStartDate.toString());
    //         let endDate: Date = new Date(this._bizzCustomerService.activeItem.freeTrialEndDate.toString());

    //         // let diff = Math.abs(endDate.getTime() - startDate.getTime());
    //         //   this.dayLeftInRenewal = Math.ceil(diff / (1000 * 3600 * 24));

    //         // this.planAmount =
    //         //  this.currentPlanSubscription.subscriptionInvoice.totalPlanCost.toString();
    //         this.currentPlanGeneralInformation = [

    //             {
    //                 title: 'Expires on:',
    //                 value: formatDate(
    //                     endDate,
    //                     'MM/dd/yyyy',
    //                     'en-US'
    //                 ),
    //             },

    //         ];
    //     } else {

    //         let details = this._bizzCustomerService.activeItem.invoice.packageDetails
    //         let selectedPlanInterval = this._bizzCustomerService.activeItem.subscriptionInterval

    //         this.subscribedPackages = this._bizzCustomerService.activeItem.currentSubscription?.subscribedPackages
    //         this.currentSubscription = this._bizzCustomerService.activeItem?.currentSubscription

    //     }

    // }

    // initSubscriptionFormInfo() {
    //     try {
    //       //  debugger
    //         if (this._bizzCustomerService.activeItem == undefined) {
    //             this._router.navigateByUrl('bizz/customers-list');
    //         } else {
    //             this.businessSetupObj = this._bizzCustomerService.activeItem.businessSetup;
    //             this.planObj = this._bizzCustomerService.activeItem.plan
    //            // let item = this._bizzCustomerService.activeItem.invoice;

    //             this.taxRate = this.businessSetupObj.taxRate;

    //             this.cancellationRequest =this.businessSetupObj.cancellationRequest;
    //             this.upgradeRequested =this.businessSetupObj.upgradeRequested;
    //             this.planName =this.planObj.title;


    //             if (this._bizzCustomerService.activeItem.isFreeTrial) {
    //                 let startDate: Date = new Date(
    //                     this._bizzCustomerService.activeItem.freeTrialStartDate.toString()
    //                 );
    //                 let endDate: Date = new Date(
    //                     this._bizzCustomerService.activeItem.freeTrialEndDate.toString()
    //                 );

    //                 // let diff = Math.abs(endDate.getTime() - startDate.getTime());
    //                 //   this.dayLeftInRenewal = Math.ceil(diff / (1000 * 3600 * 24));

    //                 // this.planAmount =
    //                 //  this.currentPlanSubscription.subscriptionInvoice.totalPlanCost.toString();
    //                 this.currentPlanGeneralInformation = [
    //                     {
    //                         title: 'Expires on:',
    //                         value: formatDate(endDate, 'MM/dd/yyyy', 'en-US'),
    //                     },
    //                 ];
    //             } else {
    //                 let details = []
    //                  //   this._bizzCustomerService.activeItem.currentSubscription.invoice .packageDetails;
    //                 let selectedPlanInterval =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscriptionInterval;

    //                 this.subscribedPackages =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscribedPackages;

    //                 console.log(this.subscribedPackages)
    //                 this.planDetails =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscriptionInvoice.plans;
    //                 this.currentLocations =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscribedPackages.find(
    //                         (f) => f.title == 'Allowed Locations'
    //                     );
    //                 this.currentRegisters =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscribedPackages.find(
    //                         (f) => f.title == 'Allowed Registers'
    //                     );
    //                 this.currentSubscription =
    //                     this._bizzCustomerService.activeItem.currentSubscription;
    //                 this.getSubPlan =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscriptionInvoice;

    //                 this.staticWebsite =
    //                     this._bizzCustomerService.activeItem.currentSubscription.subscriptionInvoice.plans[0].featureData.find(
    //                         (f) => f.typeString == 'StaticWebsite'
    //                     );
    //             }

    //             this.calculateGrandTotal();
    //         }
    //     } catch (error) {}
    // }

    initSubscriptionFormInfo(): void {
        try {
            const activeItem = this._bizzCustomerService.activeItem;

            // 🧭 If no active customer is selected, redirect
            if (!activeItem) {
                this._router.navigateByUrl('bizz/customers-list');
                return;
            }

            // 🧩 Basic setup and info extraction
            const businessSetup = activeItem.businessSetup;
            const plan = activeItem.currentSubscription;

            this.businessSetupObj = businessSetup;
            this.planObj = plan;
            this.taxRate = businessSetup?.taxRate ?? 0;
            this.cancellationRequest = businessSetup?.cancellationRequest ?? false;
            this.upgradeRequested = businessSetup?.upgradeRequested ?? false;
            // Don't fall back to activeItem.isFreeTrial here — that flag goes stale the same way
            // documented on isActuallyFreeTrial below (an account that upgraded off its free trial
            // can still carry isFreeTrial: true), and a hardcoded 'Free' here would short-circuit
            // displayPlanName's own fallback chain before it ever reaches subscribedPackagesPlanName
            // (the real plan title, e.g. "Premium", read from currentSubscription.subscribedPackages).
            this.planName = plan?.planName ?? '';

            this.subscriptionCharges = plan?.total ?? 0;

            // 🧪 Handle Free Trial Customers
            if (this.isActuallyFreeTrial) {
                const expirySource =
                    activeItem?.currentSubscription?.subscriptionExpire ||
                    activeItem?.freeTrialEndDate;
                const endDate = new Date(expirySource);
                const expiresOn = this.isValidDateValue(endDate)
                    ? formatDate(endDate, 'MM/dd/yyyy', 'en-US')
                    : '-';

                this.currentPlanGeneralInformation = [
                    {
                        title: 'Expires on:',
                        value: expiresOn,
                    },
                ];

                return this.calculateGrandTotal();
            }

            // 💼 Handle Paid Subscriptions
            const currentSub = activeItem.currentSubscription;
            if (!currentSub) return;

            this.loadLiveSubscriptionSnapshot();

            const invoice = currentSub.subscriptionInvoice;
            this.subscribedPackages = currentSub.subscribedPackages || [];
            this.planDetails = invoice?.planName || [];

            // 🔍 Extract key features
            this.currentLocations = this.subscribedPackages.find(
                (pkg) => pkg.title === 'Allowed Locations'
            );
            this.currentRegisters = this.subscribedPackages.find(
                (pkg) => pkg.title === 'Allowed Registers'
            );

            this.currentSubscription = currentSub;
            this.getSubPlan = invoice;

            // 📦 Addons from subscribedPackagesV2
            const packagesV2 = Array.isArray(currentSub?.subscribedPackagesV2)
                ? currentSub.subscribedPackagesV2
                : [];
            this.addonsList = packagesV2.filter(
                (p: any) =>
                    p?.isSubscription !== true &&
                    (p?.isAddons === true || p?.reOccurring === true)
            );

            // Hardware: GetReport's real source is the top-level hardwarePkg array — subscribedPackagesV2
            // is empty for accounts whose hardware purchase isn't reflected there (same finding
            // bizz-customer-hardware-details.component.ts's buildHardwareObj() already relies on).
            // Fall back to subscribedPackagesV2 only if hardwarePkg is absent.
            const hardwarePkg = activeItem?.hardwarePkg ?? activeItem?.HardwarePkg;
            this.hardwareList = Array.isArray(hardwarePkg)
                ? hardwarePkg
                : packagesV2.filter(
                    (p: any) =>
                        p?.isSubscription !== true &&
                        (p?.isHardware === true || p?.reOccurring === false)
                );

            // 🌐 Find Static Website feature if available
            this.staticWebsite =
                invoice?.plans?.[0]?.featureData?.find(
                    (feature) => feature.typeString === 'StaticWebsite'
                ) ?? null;

            this.buildDisplaySubscribedPackages();

            // 💰 Calculate totals
            this.calculateGrandTotal();

        } catch (error) {
            console.error('Error initializing subscription info:', error);
        }
    }

    private isValidDateValue(value: any): boolean {
        if (value === null || value === undefined || value === '' || value === '-') {
            return false;
        }
        const parsed = value instanceof Date ? value : new Date(value);
        // Backend stamps unset dates as DateTime.MinValue, which serializes as "1/1/0001" —
        // that parses to a valid (non-NaN) JS Date, so it must be excluded explicitly.
        return !isNaN(parsed.getTime()) && parsed.getFullYear() > 1900;
    }

    formatDisplayDate(value: any): string {
        if (!this.isValidDateValue(value)) {
            return '-';
        }
        return formatDate(value, 'M/d/yyyy', 'en-US');
    }

    hasLastChargeDate(): boolean {
        const lastChargeDate =
            this._bizzCustomerService.activeItem?.currentSubscription?.lastChargeDate;
        return this.isValidDateValue(lastChargeDate);
    }

    getSelectedPlanTitle(): string {
        return this.selectedPlanForSubscription?.title || '';
    }

    private buildDisplaySubscribedPackages(): void {
        const baseRows = (this.subscribedPackages || []).map((pkg: any) => ({
            ...pkg,
            isSupplemental: false,
            displayPrice: this.getNumericAmount(pkg?.totalPrice ?? pkg?.pricePerPackage),
            displayQty:
                pkg?.title === 'Allowed Locations' ||
                pkg?.title === 'Allowed Registers'
                    ? pkg?.qty
                    : null,
        }));

        const addonRows = (this.addonsList || []).map((pkg: any) => ({
            title: pkg?.name,
            qty: pkg?.qty,
            displayQty: pkg?.qty,
            displayPrice: this.getNumericAmount(pkg?.totalPrice ?? pkg?.pricePerPackage),
            isSupplemental: true,
        }));

        const hardwareRows = (this.hardwareList || []).map((pkg: any) => ({
            title: pkg?.name,
            qty: pkg?.qty,
            displayQty: pkg?.qty,
            displayPrice: this.getNumericAmount(pkg?.totalPrice ?? pkg?.pricePerPackage),
            isSupplemental: true,
        }));

        this.displaySubscribedPackages = [...baseRows, ...addonRows, ...hardwareRows];
        this.displaySubTotal = this.displaySubscribedPackages.reduce(
            (sum: number, pkg: any) => sum + this.getNumericAmount(pkg?.displayPrice),
            0
        );
        this.displayTax = this.getNumericAmount(this.currentSubscription?.tax);

        const apiTotal = this.getNumericAmount(this.currentSubscription?.total);
        this.displayTotalCharges = apiTotal > 0
            ? apiTotal
            : this.displaySubTotal + this.displayTax;
    }

    private getNumericAmount(value: any): number {
        if (typeof value === 'number') {
            return Number.isFinite(value) ? value : 0;
        }

        if (typeof value === 'string') {
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : 0;
        }

        if (value && typeof value === 'object') {
            const parsedValue = Number(value?.parsedValue);
            if (Number.isFinite(parsedValue)) {
                return parsedValue;
            }

            const sourceValue = Number(value?.source);
            if (Number.isFinite(sourceValue)) {
                return sourceValue;
            }
        }

        return 0;
    }


    getUserCurrentSubscriptionDetails() {
        this.loadingContent = true;
        this._subscriptionPlanService.getBusinessInvoice().subscribe(
            (res: UserSubscriptionInfo) => {
                if (res.responseStatusCode == 903) {
                    this.currentPlanSubscription = res.data;
                    this._bizzCustomerService.activeItem = {
                        ...(this._bizzCustomerService.activeItem || {}),
                        ...(res.data || {})
                    };

                    this.planPricePerMonth =
                        this._bizzCustomerService.activeItem.subscriptionInvoice?.plans[0]?.prices[1]?.value;
                    if (
                        this._bizzCustomerService.activeItem
                            .subscriptionInterval == 12
                    ) {
                        this.planPricePerMonth =
                            this._bizzCustomerService.activeItem.subscriptionInvoice?.plans[0]?.prices[0]?.value;
                    }

                    let selectedPlanInterval =
                        this._bizzCustomerService.activeItem
                            .subscriptionInterval;
                    if (selectedPlanInterval == 12) {
                        this.basePlanPrice =
                            this.planPricePerMonth * selectedPlanInterval;
                        this.costHeading =
                            '$' +
                            this.planPricePerMonth +
                            '/per month X ' +
                            selectedPlanInterval +
                            ' = $' +
                            this.planPricePerMonth * selectedPlanInterval +
                            ' billed annually';
                    } else {
                        this.basePlanPrice = this.planPricePerMonth;
                        this.costHeading =
                            '$' +
                            this.planPricePerMonth +
                            '/per month billed monthly';
                    }

                    this.loadingContent = false;
                    this.initSubscriptionFormInfo();
                }
            },
            (error) => {
                this.loadingContent = false;
            }
        );
    }

    upgrade() {
        this._confirmationService.confirm({
            header: `Subscription Change Confirmation`,
            message:
                'Are you sure that you want to perform upgrade your subscription?',
            accept: () => {
                try {
                    this._abd.showSpinner();
                    this._subscriptionPlanService
                        .renewSubscription()
                        .subscribe((res) => {
                            if (res.success) {
                                this.showSubscriptionModal = true;
                                this.disabledTrue = true;
                                this._spinner.hide();
                            }
                        });
                } catch {
                    this._abd.hideSpinner();
                }
            },
        });
    }

    // Sam Changes Start

    getSubscriptionPlansUpdated() {
        try {
            this._spinner.show();
            this._signup.getSubscriptionPlans().subscribe((res) => {
                if (res.success) {
                    this._spinner.hide();

                    this._signup.subscriptionPlans = res.data;
                    this.currentPlanID =
                        this._bizzCustomerService.activeItem.subscriptionInvoice?.plans[0]?.planId;
                }
            });
        } catch {
            this._spinner.hide();
        }
    }

    changeSubscriptionPeriod(e: any) {
        this.selectedBillingPeriod = e.value;

        this.calculateGrandTotal();
    }

    choseDifferentPlan(obj: any) {
        this.planDetails.map((f) => (f.currentUserSelectedPlan = false));
        obj.currentUserSelectedPlan = true;

        this.calculateGrandTotal();
    }

    updateQuantity(input: any, obj: AdditionItemsPriceInfo) {
        const locationItem = this.additionItemsPriceInfo?.[0];
        const registerItem = this.additionItemsPriceInfo?.[1];
        if (!locationItem || !registerItem || !obj) {
            this.calculateGrandTotal();
            return;
        }

        if (input.value != null && parseInt(input.value) > 0) {
            if (obj.id == 1) {
                if (this.totalLocation > parseInt(input.value)) {
                    registerItem.quantity = registerItem.quantity - 1;
                } else {
                    registerItem.quantity = registerItem.quantity + 1;
                }

                obj.includeQuantity = input.value;
                this.totalLocation = input.value;
                //this.additionItemsPriceInfo[1].includeQuantity += 1;
                obj.totalCost = obj.actualPrice * obj.includeQuantity;

                if (obj.includeQuantity <= 0) {
                    registerItem.disabled = true;
                    this.totalRegisters = 0;
                    registerItem.quantity = 0;
                    registerItem.includeQuantity = 0;
                } else {
                    registerItem.disabled = false;
                }
            } else {
                if (
                    parseInt(input.value) <
                    locationItem.quantity
                ) {
                    setTimeout(() => {
                        input.value = locationItem.quantity;
                        registerItem.quantity = locationItem.quantity;
                    }, 200);
                    return false;
                    // this.additionItemsPriceInfo[1].disabled = false;
                }
                if (this.totalRegisters > parseInt(input.value)) {
                    // obj.quantity = obj.quantity - 1;
                    obj.includeQuantity = obj.includeQuantity - 1;
                } else {
                    obj.includeQuantity = obj.includeQuantity + 1;
                }

                this.totalRegisters = obj.quantity;
                obj.totalCost = obj.actualPrice * obj.includeQuantity;

                // this.additionItemsPriceInfo[1].disabled = true;
            }
            this.calculateGrandTotal();
        } else {
            setTimeout(() => {
                input.value = 1;
                obj.quantity = 1;
                obj.actualPrice = 1;
                obj.totalCost = obj.actualPrice * 1;
                this.calculateGrandTotal();
            }, 200);
        }
    }

    calculateGrandTotal() {
        const locationItem = this.additionItemsPriceInfo?.[0];
        const registerItem = this.additionItemsPriceInfo?.[1];
        const baseSubscriptionCost = Number(this.subscriptionCharges || this.subscriptionCost || 0);

        if (!locationItem || !registerItem) {
            this.additionalLocationCost = 0;
            this.additionalRegisterCost = 0;
            this.grandBill = baseSubscriptionCost;
            return;
        }

        if (this.additionalLocationNotAvailable) {
            locationItem.quantity = 0;
            registerItem.quantity = 0;
            locationItem.includeQuantity = 0;
            registerItem.includeQuantity = 0;
        } else {
            locationItem.quantity = 1;
            registerItem.quantity = 1;
            locationItem.includeQuantity = 1;
            registerItem.includeQuantity = 1;
        }
        this.additionalLocationCost = Number(locationItem.totalCost || 0);
        this.additionalRegisterCost = Number(registerItem.totalCost || 0);
        this.grandBill =
            this.additionalLocationCost +
            this.additionalRegisterCost +
            baseSubscriptionCost;
    }

    resetQuantity(obj: AdditionItemsPriceInfo) { }

    setValueInputsOldValue(oldValue: any, obj: AdditionItemsPriceInfo) { }
    getWordsWithSpace(str) {
        return str.replace(/[A-Z]/g, ' $&').trim();
    }

    onDesktopScreen() {
        return window.innerWidth > 991;
    }
    onMobileScreen() {
        return window.innerWidth < 992;
    }

    cancel() {
        this._confirmationService.confirm({
            header: `Subscription Cancel`,
            message: 'Are you sure you want to cancel your subscription? You will not be able to undo this without contacting support.',
            accept: () => {
                let isStripe = false;
                if (this._globals.userInfo.businessSetup[0]?.subscription?.transactionDetails?.paymentMethod === "Stripe") {
                    isStripe = true
                } else {
                    isStripe = false
                }

                try {
                    this._abd.showSpinner();
                    this._subscriptionPlanService
                        .cancelSubscriptionByCustomer(isStripe)
                        .subscribe((res) => {
                            if (res.success) {
                                this.showSubscriptionModal = true;
                                this.disabledTrue = true;
                                this._spinner.hide();
                                this._userService.logout();
                            }
                        });
                } catch {
                    this._abd.hideSpinner();
                }
            },
        });
    }
    buyLocationFormHandler() {
        this.showBuyMoreLocationForm = true;
    }
    generateSupportRequest(subject = '') {
        this.generalQuestion = subject;
        this.showSupportRequestForm = true;
        this.showPurchaseAddon = false;
    }
    buyRegisterFormHandler() {
        this.showBuyMoreRegisterForm = true;
    }
    purchaseAddonHandler() {
        this.showPurchaseAddon = true;
    }
    talkToExpertRequestForm() {
        this.talkToExpertForm = true;
        this.showPurchaseAddon = false;
    }
    showPopuptoSelectWebsite() {
        this.showWebsiteSelectionPopup = true;
    }
    showLoyaltyFormPopup() {
        this.showLoyaltyProgramSelectionPopup = true;
    }
    submitTalkExpertFormRequest() {
        const obj = {
            // buyNoOfLocations: this.buyLocQty,
            userEmail: this._bizzCustomerService.activeItem.email,
            companyName: this._globals.userInfo.companyName,
            question: this.addtionalAddonsQuestion,
            message: this.additionalAddonRequestionMessage,
        };
        this.talkToExpertForm = false;
        const _url = environment.BaseURL + 'EmailForAddonsPlan';
        // const _url= 'https://connect360-stg.azure-api.net/account-svc/api/BusinessSubscription?operation=Update&updateItem=Locations&execute=true'

        this._confirmationService.confirm({
            header: `Additonal Addons Message Confirmation`,
            message: `Are you sure you want to send this message to our expert person of our team?.`,
            accept: () => {
                try {
                    this.talkToExpertForm = false;
                    this._abd.showSpinner();
                    this._bs
                        .httpPost(
                            _url,
                            obj,
                            false,
                            true,
                            this._bizzCustomerService.activeItem
                                .currentSubscription.businessNameWithDomain
                        )
                        .subscribe((res) => {
                            this._spinner.hide();
                            if (res.success) {
                                this._connMessageService.showToastMessage(
                                    'Thank you! Your request is sent to our support team, someone from our team will contact you as soon as possible.',
                                    'success'
                                );
                                this.addtionalAddonsQuestion = '';
                                this.additionalAddonRequestionMessage = '';
                            }
                        });
                } catch {
                    this.talkToExpertForm = false;
                    this._abd.hideSpinner();
                }
            },
            reject: (type) => {
                this.talkToExpertForm = true;
                // verifyObj.isVerified = !e.checked;
            },
        });
    }
    submitGeneralRequest() {
        const obj = {
            userEmail: this._bizzCustomerService.activeItem.email,
            companyName: this._globals.userInfo.companyName,
            question: this.generalQuestion,
            message: this.generalMessage,
        };
        this.showSupportRequestForm = false;
        const _url = environment.BaseURL + 'EmailForAddonsPlan';

        this._confirmationService.confirm({
            header: `Support Request Confirmation`,
            message: `Are you sure you want to send this message to our business team?.`,
            accept: () => {
                try {
                    this.showSupportRequestForm = false;
                    this._abd.showSpinner();
                    this._bs
                        .httpPost(
                            _url,
                            obj,
                            false,
                            true,
                            this._bizzCustomerService.activeItem
                                .currentSubscription.businessNameWithDomain
                        )
                        .subscribe((res) => {
                            this._spinner.hide();
                            if (res.success) {
                                this._connMessageService.showToastMessage(
                                    'Thank you! Your request is sent to our support team, someone from our team will contact you as soon as possible.',
                                    'success'
                                );
                                this.generalMessage = '';
                            }
                        });
                } catch {
                    this.showSupportRequestForm = false;
                    this._abd.hideSpinner();
                }
            },
            reject: (type) => {
                this.showSupportRequestForm = true;
            },
        });
    }
    submitHardwareCatalogRequest() {
        const obj = {
            userEmail: this._bizzCustomerService.activeItem.email,
            companyName: this._globals.userInfo.companyName,
            question: 'Request for Hardware Catalog',
            message: 'Contact me',
        };
        this.showPurchaseAddon = false;
        const _url = environment.BaseURL + 'EmailForAddonsPlan';
        this._confirmationService.confirm({
            header: `Additional Hardware Request Confirmation`,
            message: `Are you sure you want to request additional hardware catalog details from our business team?`,
            accept: () => {
                try {
                    this.showPurchaseAddon = false;
                    this._abd.showSpinner();
                    this._bs
                        .httpPost(
                            _url,
                            obj,
                            false,
                            true,
                            this._bizzCustomerService.activeItem
                                .currentSubscription.businessNameWithDomain
                        )
                        .subscribe((res) => {
                            this._spinner.hide();
                            if (res.success) {
                                this._connMessageService.showToastMessage(
                                    'Thank you! Your request is sent to our support team, someone from our team will contact you as soon as possible.',
                                    'success'
                                );
                            }
                        });
                } catch {
                    this.showPurchaseAddon = false;
                    this._abd.hideSpinner();
                }
            },
            reject: (type) => {
                this.showPurchaseAddon = true;
            },
        });
    }
    locationQtyChanged(e = null) {
        const obj = {
            buyNoOfLocations: this.buyLocQty,
        };
        const _url =
            environment.BusinessBaseURL +
            'BusinessSubscription?operation=Update&updateItem=Locations&execute=false';
        this._spinner.show();
        this._bs
            .httpPut(
                _url,
                obj,
                false,
                true,
                this._bizzCustomerService.activeItem.currentSubscription
                    .businessNameWithDomain
            )
            .subscribe((res) => {
                if (res.success) {
                    this.buylocationList = res.data;

                    this._spinner.hide();
                }
            });
    }
    registerQtyChanged(e, businessName = '') {
        const obj = {
            buyNoOfRegisters: this.buyRegQty,
        };
        const _url =
            environment.BusinessBaseURL +
            'BusinessSubscription?operation=Update&updateItem=Registers&execute=false';
        this._spinner.show();
        this._bs
            .httpPut(
                _url,
                obj,
                false,
                true,
                this._bizzCustomerService.activeItem.currentSubscription
                    .businessNameWithDomain
            )
            .subscribe((res) => {
                if (res.success) {
                    this.buyRegisterList = res.data;
                    this._spinner.hide();
                }
            });
    }
    postBuyLocation(businessName = '') {
        const obj = {
            buyNoOfLocations: this.buyLocQty,
        };
        this.showBuyMoreLocationForm = false;
        const _url =
            environment.BusinessBaseURL +
            'BusinessSubscription?operation=Update&updateItem=Locations&execute=true';

        this._confirmationService.confirm({
            header: `Buy Location Confirmation`,
            message: `Are you sure you want to buy additional Location?.`,
            accept: () => {
                try {
                    this.showBuyMoreLocationForm = false;
                    this._abd.showSpinner();
                    this._bs
                        .httpPut(
                            _url,
                            obj,
                            false,
                            true,
                            this._bizzCustomerService.activeItem
                                .currentSubscription.businessNameWithDomain
                        )
                        .subscribe((res) => {
                            this._spinner.hide();
                            if (res.success) {
                                this._connMessageService.showToastMessage(
                                    'You have successfully purchased additional location.',
                                    'success'
                                );
                                this.initSubscriptionFormInfo();
                            }
                        });
                } catch {
                    this.showBuyMoreLocationForm = false;
                    this._abd.hideSpinner();
                }
            },
            reject: (type) => {
                this.showBuyMoreLocationForm = true;
                // verifyObj.isVerified = !e.checked;
            },
        });
    }
    postBuyRegisters() {
        const obj = {
            BuyNoOfRegisters: this.buyRegQty,
        };
        this.showBuyMoreRegisterForm = false;
        const _url =
            environment.BusinessBaseURL +
            'BusinessSubscription?operation=Update&updateItem=Registers&execute=true';
        this._confirmationService.confirm({
            header: `Buy Additional Register Confirmation`,
            message: `Are you sure you want to buy additional Register?.`,
            accept: () => {
                try {
                    this.showBuyMoreRegisterForm = false;
                    this._abd.showSpinner();
                    this._bs
                        .httpPut(
                            _url,
                            obj,
                            false,
                            true,
                            this._bizzCustomerService.activeItem
                                .currentSubscription.businessNameWithDomain
                        )
                        .subscribe((res) => {
                            this._spinner.hide();
                            if (res.success) {
                                this._connMessageService.showToastMessage(
                                    'You have successfully purchased additional register.',
                                    'success'
                                );
                                this.initSubscriptionFormInfo();
                            }
                        });
                } catch {
                    this.showBuyMoreRegisterForm = false;
                    this._abd.hideSpinner();
                }
            },
            reject: (type) => {
                this.showBuyMoreRegisterForm = true;
            },
        });
    }
    upgradePlan(execute = false) {
        this.ErrorMessage = '';
        if (!execute) this.changePlanButtonClicked();
        else {
            //show a popup here see slide number 9
            this.CurrentAction = 1;
            this.ShowCustomConfirmation = true;
            this.upgradeSubPlan('false');
        }
    }
    downgradePlan(execute = false) {
        this.ErrorMessage = '';
        if (!execute) this.changePlanButtonClicked();
        else {
            //show a popup here see slide number 9
            this.CurrentAction = 2;
            this.ShowCustomConfirmation = true;
            this.downgradeSubPlan('false');
        }
    }

    ErrorMessage = '';
    currentSubscriptionCharges = 0;
    newSubscriptionCharges = 0;
    subscriptionChangeNotes = '';
    upgradeSucessMessage = '';
    upgradeSubPlan(execute = 'true') {
        let Sucess = false;
        try {
            this.ErrorMessage = '';
            this.upgradeSucessMessage = '';
            this._abd.showSpinner();
            let newplan = {
                BuySubscriptionPlanId: this.selectedPlanForSubscription.planId,
            };
            this._subscriptionPlanService
                .upgradeSubscription(newplan, true, execute)
                .subscribe((res) => {
                    if (res.success) {
                        Sucess = true;
                        this.subscriptionChangeNotes = res.data.note;
                        this.currentSubscriptionCharges =
                            res.data.currentSubscriptionCharges;
                        this.newSubscriptionCharges =
                            res.data.newSubscriptionCharges;
                        if (execute == 'true') {
                            this.upgradeSucessMessage =
                                'You have sucessfully updated your plan.';
                            this.getSubscriptionPlansUpdated();
                            this.getEcomSubscriptionPlans();
                            this.getUserCurrentSubscriptionDetails();
                        }
                    } else {
                        this.ErrorMessage =
                            'Plan change failed, Please try again or contact support!';
                    }
                });
        } catch { }
    }

    getEcomSubscriptionPlans() {
        this._signup.getEComSubscriptionPlans().subscribe((res) => {
            if (res.success) {
                this._signup.eComSubscriptionPlans = res.data;

                let obj = this._signup.eComSubscriptionPlans;
                for (let i = 0; i < obj.length; i++) {
                    obj[i].selected = false;
                    obj[i].wantDomain = 0;
                }
                // console.log('this._signup.eComSubscriptionPlans', this._signup.eComSubscriptionPlans)
            }
        });
    }
    downgradeSubPlan(execute = 'true') {
        let Sucess = false;
        this.upgradeSucessMessage = '';
        try {
            this.ErrorMessage = '';
            this._abd.showSpinner();
            let newplan = {
                BuySubscriptionPlanId: this.selectedPlanForSubscription.planId,
            };
            this._subscriptionPlanService
                .upgradeSubscription(newplan, false, execute)
                .subscribe((res) => {
                    if (res.success) {
                        Sucess = true;
                        this.subscriptionChangeNotes = res.data.note;
                        this.currentSubscriptionCharges =
                            res.data.currentSubscriptionCharges;
                        this.newSubscriptionCharges =
                            res.data.newSubscriptionCharges;
                        if (execute == 'true') {
                            this.upgradeSucessMessage =
                                'You have sucessfully updated your plan.';
                        }
                    } else {
                        this.ErrorMessage =
                            'An error occured during the operation, please try again.';
                    }
                });
        } catch {
        } finally {
        }
    }

    cancelSubscription(actionType: string) {
        try {
            if (actionType == 'c') {
                this.cancel();
            }
            if (actionType == 'r') {
                this.upgradePlan();
            }
        } catch (error) { }
    }

    changePlanButtonClicked() {
        this._signup.subscriptionPlans
            .filter((f) => f.isTrial || f.isCustom)
            .map((f) => (f.showPlan = false));
        this._signup.subscriptionPlans
            .filter((f) => !f.isTrial && !f.isCustom)
            .map((f) => (f.showPlan = true));
        this.selectedPlanForSubscription =
            this._bizzCustomerService.activeItem.subscriptionInvoice?.plans[0];

        this.displaySubscriptionPlan = true;

        let subscriptionAgain: any =
            sessionStorage.getItem('sub-from-dashboard');

        if (subscriptionAgain != undefined) {
            this.planChanged = true;
        }
    }

    closeDialogSubscriptionPlan(selectedPlan: any) {
        try {
            this.selectedPlanForSubscription = selectedPlan;
        } catch (error) { }
    }

    closeSubscriptionModal(buttonType: number) {
        try {
            this.displaySubscriptionPlan = false;
            if (this._bizzCustomerService.activeItem.isFreeTrial) {
                this._signup.showPlanSelectionModal = false;
                if (buttonType == 2) {
                    sessionStorage.setItem(
                        'selectedPlan',
                        JSON.stringify(this.selectedPlanForSubscription)
                    );
                    sessionStorage.setItem('free-trial-account', '0');
                    sessionStorage.setItem('un-verified-account', '1');
                    sessionStorage.setItem('currentStep', '4');
                    sessionStorage.setItem('savedSteps', '4');
                    sessionStorage.setItem('accountVerified', '1');
                    sessionStorage.setItem('sub-from-dashboard', '1');
                    sessionStorage.setItem(
                        'locationsQty',
                        this._signup.checkoutPageCalcVars.locationsQty
                    );
                    sessionStorage.setItem(
                        'registersQty',
                        this._signup.checkoutPageCalcVars.registersQty
                    );
                    sessionStorage.setItem(
                        'selectedPlanTimeframe',
                        this._signup.selectedPlanTimeframe
                    );

                    this._signup.selectedPlan =
                        this.selectedPlanForSubscription;
                    this._signup.customerBillTo = {
                        firstName: this._globals.userInfo.firstName,
                        lastName: this._globals.userInfo.lastName,

                        email: this._bizzCustomerService.activeItem.email,
                        company: this._globals.userInfo.companyName,
                        address:
                            this._globals.userInfo.businessSetup[0].address,
                        city: this._globals.userInfo.businessSetup[0].city,
                        state: this._globals.userInfo.businessSetup[0].state,
                        zip: this._globals.userInfo.businessSetup[0].zip,
                        country: 'USA',
                    };

                    this._signup.businessInfo = {
                        businessId:
                            this._globals.userInfo.businessSetup[0].businessId,
                        userId: this._globals.userInfo.businessSetup[0].userID,
                        companyName: this._globals.userInfo.companyName,
                        industryTypeId:
                            this._globals.userInfo.businessSetup[0].industry,
                        phone: this._globals.userInfo.businessSetup[0].phone,
                        email: this._bizzCustomerService.activeItem.email,
                        address:
                            this._globals.userInfo.businessSetup[0].address,
                        zip: this._globals.userInfo.businessSetup[0].zip,
                        city: this._globals.userInfo.businessSetup[0].city,
                        state: this._globals.userInfo.businessSetup[0].state,
                        selectedState: null,
                        userID: this._globals.userInfo.businessSetup[0].userID,
                    };
                    sessionStorage.setItem(
                        'step-2',
                        JSON.stringify(this._signup.businessInfo)
                    );

                    this.router.navigate(['/setup/signup']);
                } else {
                    this.displaySubscriptionPlan = false;
                }
            }
            //user have a plan
            //check if plan is not same as customer already have
            else {
                if (buttonType == 2) {
                    if (
                        this.selectedPlanForSubscription.planId >
                        this._bizzCustomerService.activeItem.currentSubscription
                            ?.planId
                    ) {
                        this.upgradePlan(true);
                    } else if (
                        this.selectedPlanForSubscription.planId <
                        this._bizzCustomerService.activeItem.currentSubscription
                            ?.planId
                    ) {
                        this.downgradePlan(true);
                    } else {
                    }
                }
            }
        } catch (error) { }
    }

    subscriptionPlanChanged(s: boolean) {
        try {
            this.planChanged = s;
        } catch (error) { }
    }
}

